import { gql } from 'apollo-angular';

export const NOTIFICATION_TEMPLATES = gql`
  query notificationTemplates($search: String) {
    notificationTemplates(search: $search) {
      id
      templateName
      code
      channel
      subject
      body
      isActive
      placeholders
      status
    }
  }
`;

export const GET_SERVICE_DROPDOWN = gql`
  query serviceDropDown($search: String) {
    serviceDropDown(search: $search) {
      id
      serviceName
      serviceCode
      totalPrice
    }
  }
`;

export const GET_NOTIFICATION_BY_ID = gql`
  query notificationTemplate($id: Int!) {
    notificationTemplate(id: $id) {
      id
      templateName
      code
      channel
      subject
      body
      isActive
      placeholders
      status
    }
  }
`;
